import { IneligibleCode } from '../models/enrollment'

const INELIGIBLE_MESSAGES: Record<IneligibleCode, string> = {
  NO_PRIOR_SCHOOL_YEAR: 'Chưa có dữ liệu năm học trước trong hệ thống.',
  NO_ENROLLMENT_LAST_YEAR:
    'Năm ngoái đoàn sinh không học ở xứ. Nếu muốn đăng ký, xin vui lòng đến văn phòng đoàn vào 9h sáng Chủ Nhật.',
  UNKNOWN_LAST_PROGRAM: 'Không xác định được lớp năm trước. Vui lòng liên hệ giáo xứ.',
  NO_NEXT_PROGRAM: 'Không tìm thấy lớp phù hợp. Vui lòng liên hệ giáo xứ.',
  COMPLETED_PROGRAM: 'Đoàn sinh đã hoàn thành chương trình giáo lý.',
  LAST_YEAR_NOT_GRADED: 'Chưa hoàn tất chương trình cũ.',
}

// Khi đã đóng ghi danh online thì không còn đường ghi danh nào nữa, nên câu chỉ
// phụ huynh lên văn phòng thành sai — chỉ nêu hiện trạng. Các lý do còn lại là lỗi
// dữ liệu, cần liên hệ giáo xứ bất kể kỳ ghi danh mở hay đóng, nên giữ nguyên.
const MESSAGES_WHEN_CLOSED: Partial<Record<IneligibleCode, string>> = {
  NO_ENROLLMENT_LAST_YEAR: 'Hiện tại đoàn sinh không theo học tại xứ đoàn.',
}

/**
 * @param enrollmentOpen Chưa biết (`undefined`, config đang tải) thì trả null cho những
 * lý do có câu phụ thuộc trạng thái, để không nháy câu sai rồi đổi khi config về.
 */
export const ineligibleMessage = (
  code?: IneligibleCode | string | null,
  enrollmentOpen?: boolean
): string | null => {
  if (!code) {
    return null
  }

  const key = code as IneligibleCode
  const closedVariant = MESSAGES_WHEN_CLOSED[key]
  if (closedVariant) {
    if (enrollmentOpen == null) {
      return null
    }
    return enrollmentOpen ? INELIGIBLE_MESSAGES[key] : closedVariant
  }

  return INELIGIBLE_MESSAGES[key] ?? null
}
